import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import global_en from "./translations/en/global.json";
import global_nl from "./translations/nl/global.json";
import about_en from "./translations/en/about.json";
import about_nl from "./translations/nl/about.json";
import acco_en from "./translations/en/acco.json";
import acco_nl from "./translations/nl/acco.json";
import contact_en from "./translations/en/contact.json";
import contact_nl from "./translations/nl/contact.json";
import roomDetails_en from "./translations/en/roomDetails.json";
import roomDetails_nl from "./translations/nl/roomDetails.json";
import headerFooter_en from "./translations/en/headerFooter.json"
import headerFooter_nl from "./translations/nl/headerFooter.json"

const resources = {
    nl: {
        global: global_nl,
        about: about_nl,
        acco: acco_nl,
        contact: contact_nl,
        roomDetails: roomDetails_nl,
        headerFooter: headerFooter_nl,
    },
    en: {
        global: global_en,
        about: about_en,
        acco: acco_en,
        contact: contact_en,
        roomDetails: roomDetails_en,
        headerFooter: headerFooter_en,
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "nl",
        fallbackLng: "nl",
        ns: ["global", "about", "acco", "contact", "roomDetails", "headerFooter"],
        defaultNS: "global",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;